export default (seedsPerMeter, groovesDistance) => {
  if (Boolean(seedsPerMeter) && Boolean(groovesDistance) && !isNaN(seedsPerMeter)) {
    return Math.trunc((100 / groovesDistance) * seedsPerMeter * 10000);
  }
  return '-';
};
